// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__LBnyi","list":"styles_list__2nNiy"};